import React from 'react';
import Header from '../../components/header';
import HeaderBackButton from '../../components/header-back-button';
import { TextEditorMobileToolbar } from '../../components/styled-text-editor';
import { PostPublishButton } from '../publish-button';

const PostCreatePageHeader = () =>
  <Header
    left={<HeaderBackButton/>}
    right={<PostPublishButton formName="post"/>}
    menu={<TextEditorMobileToolbar identifier="post"/>}
  />;

export default PostCreatePageHeader;



// WEBPACK FOOTER //
// ./app/containers/post-create-page-header/post-create-page-header.js